import { FC, useEffect } from 'react';
import { Routes, Route, BrowserRouter, Navigate } from 'react-router';
import { PrivateRoutes } from './PrivateRoutes';
import { ErrorsPage } from '../modules/errors/ErrorsPage';
import { Logout, AuthPage } from '../modules/auth';
import { App } from '../App';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { refreshAccessToken } from '../redux/auth/authSlice';
import { AppDispatch } from '../redux/store';

const { BASE_URL } = import.meta.env;

const AppRoutes: FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { currentClient, initialized } = useSelector((state: RootState) => state.auth);
  const { twoFAOtpCodeResponse } = useSelector((state: RootState) => state.twoFactorAuth);
  const { changedPasswordSuccessfully, resetPasswordSuccessfully } = useSelector((state: RootState) => state.passwordSettings);
  useEffect(() => {
    if (!initialized) dispatch(refreshAccessToken());
  }, [dispatch, initialized, twoFAOtpCodeResponse, changedPasswordSuccessfully, resetPasswordSuccessfully]);


  const renderRoutes = () => {

    if (!initialized) {
      return (
        <>
          <Route path="*" element={<div className="app-boot-state" role="status"><span className="spinner-border spinner-border-sm" /> Loading secure session…</div>} />
        </>
      );
    }

    if (currentClient == null) {
      return (
        <>
          <Route path="auth/*" element={<AuthPage />} />
          <Route path="*" element={<Navigate to="/auth" replace />} />
        </>
      );
    }

    if (!currentClient.itfa && currentClient.ipcr) {
      return (
        <>
          <Route path="auth/*" element={<AuthPage />} />
          <Route path="*" element={<Navigate to="/auth/change-password" replace />} />
        </>
      );
    }

    if (currentClient.itfa && !currentClient.itfavc) {
      return (
        <>
          <Route path="auth/*" element={<AuthPage />} />
          <Route path="*" element={<Navigate to="/auth/two-factor-auth" replace />} />
        </>
      );
    }

    if (currentClient.itfa && currentClient.itfavc && currentClient.ipcr) {
      return (
        <>
          <Route path="auth/*" element={<AuthPage />} />
          <Route path="*" element={<Navigate to="/auth/change-password" replace />} />
        </>
      );
    }

    return <Route path="/*" element={<PrivateRoutes />} />;
  };


  return (
    <BrowserRouter basename={BASE_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path="error/*" element={<ErrorsPage />} />
          <Route path="logout" element={<Logout />} />
          {renderRoutes()}
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export { AppRoutes };
